import {useEffect, useMemo, useState} from 'react';


const useIntersectionObserver = (
    DOMElement:HTMLElement, // 需要绑定上Intersection Observer的DOM节点
    ctx: {
        successCallback?: any; failCallback?: any;
    }
) => {
    const [shouldObserve, setShouldObserve] = useState(false);

    const intersectionObserver = useMemo(() => {
        if (!window?.IntersectionObserver) {
            return;
        }
        return new IntersectionObserver((entries) => {
            if (!shouldObserve) {
                return;
            }
            if (!entries[0].isIntersecting) {
                ctx.failCallback && ctx.failCallback();
                return;
            }
            ctx.successCallback && ctx.successCallback();
        }, {
            threshold: [1],
        });
    }, [shouldObserve, ctx]);

    useEffect(() => {
        if (!DOMElement || !window?.IntersectionObserver) {
            return;
        }
        intersectionObserver?.observe(DOMElement);
        return () => {
            intersectionObserver?.unobserve(DOMElement);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DOMElement, intersectionObserver]);

    // 是否观察交给外部
    return {
        shouldObserve, setShouldObserve,
    };
};

export default useIntersectionObserver;
